export function scrollToTop() {

    if (window.scrollTo) {
        window.scrollTo(0, 0);
    }
}

export function scrollToUrlHash() {
    scrollToElement(window.location.hash);
}

export function scrollToElement(querySelector) {
    const HEADER_HEIGHT = 75;
    const HEADER_TO_CONTENT_SPACER = 10;

    if (querySelector) {
        let elem = document.querySelector(querySelector);

        if (elem) {
            const bodyRect = document.body.getBoundingClientRect().top;
            const elementRect = elem.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            const offsetPosition = elementPosition - HEADER_HEIGHT - HEADER_TO_CONTENT_SPACER;
            document.body.scrollTop = document.documentElement.scrollTop = offsetPosition;
        }
    }
}

export function scrollToFirstError(errors) {

    const errorEl = document.querySelector(
        Object.keys(errors).map(fieldName => `[name="${fieldName}"]`).join(',')
    );

    if (errorEl && errorEl.focus) {

        if (window.scrollTo) {
            window.scrollTo(0, errorEl.offsetTop - 105)
        }

        errorEl.focus();
    }
}
